import { Component, OnInit } from '@angular/core';
import { StatefulComponent } from '../stateful/stateful.component';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { NgIf } from '@angular/common';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { authModuleBaseRoute, authModuleRoutes } from '../../routes/api-authorization-routes';
import { userModuleBaseRoute, userModuleRoutes } from '../../routes/user-routes';
import { invoiceModuleBaseRoute, invoiceModuleRoutes } from '../../routes/invoice-routes';
import { FormsModule } from '@angular/forms';
import { filter } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    NgIf,
    NgbDropdownModule,
    // NgTemplateOutlet,
    FormsModule
  ],
})
export class HeaderComponent extends StatefulComponent implements OnInit {
  userRoute = userModuleBaseRoute;
  userModuleRoutes = userModuleRoutes;
  authRoute = authModuleBaseRoute;
  authModuleRoutes = authModuleRoutes;
  invoiceRoute = invoiceModuleBaseRoute;
  invoiceModuleRoutes = invoiceModuleRoutes;
  isHome = false;

  constructor(private router: Router) {
    super();
  }

  ngOnInit() {
    this.subs.push(this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((navData) => {
        if (navData.urlAfterRedirects === '/') {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
      }
    ));
  }

  hasAdminPermissions() {
    return (
      this.permissions?.includes('APP_MANAGEMENT') ||
      this.permissions?.includes('USER_MANAGEMENT') ||
      this.permissions?.includes('PRODUCT_MANAGEMENT')
    );
  }
}

